import { ExpandedTooltip, Icon, InputWithIcon, PasswordInput, PhoneInput } from '@livable/saas-react-components';
import { Box, Container, Typography, Grid, Link, TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, FormControlLabel, FormGroup, Checkbox, Radio, Switch, RadioGroup } from '@mui/material';
import React from 'react';
import Dropzone from 'src/components/general/Dropzone';
import FileUploader from 'src/components/shared/FileUploader';
import useStyles from '../styles';
const dropzoneExample = "\nimport Dropzone from 'src/components/general/Dropzone';\n\n<Dropzone />\n";
const fileUploaderExample = "\nimport FileUploader from 'src/components/shared/FileUploader';\n\n<FileUploader label=\"text\" icon={<React.node />} />\n";
const checkboxExample = "\n<FormGroup>\n  <FormControlLabel\n    control={<Checkbox />}\n    label=\"Label\" />\n</FormGroup>\n";
const radioButtonExample = "\n<RadioGroup>\n  <FormControlLabel\n    value=\"female\"\n    control={<Radio />}\n    label=\"Female\" />\n</RadioGroup>\n";
const toggleExample = "\n<FormGroup>\n  <FormControlLabel\n    control={<Switch />}\n    label=\"Text along side action icon\" />\n</FormGroup>\n";
const formHintExample = "\n<Typography variant=\"formHint\" state=\"success\">\n  <Icon fontSize=\"small\" type=\"success\" />\n  Some unmet requirement.\n</Typography>\n";
const passwordInputExample = "\nimport { PasswordInput } from '@livable/saas-react-components';\n\n<PasswordInput label=\"Password\" />\n";
const inputWithTooltipExample = "\nimport { ExpandedTooltip } from '@livable/saas-react-components';\n\n<FormControl variant=\"outlined\" fullWidth>\n  <InputLabel htmlFor=\"username\">Username</InputLabel>\n  <OutlinedInput\n    id=\"username\"\n    type=\"text\"\n    label=\"Username\"\n    endAdornment={\n      <InputAdornment position=\"end\" type=\"infoTooltip\">\n        <ExpandedTooltip type=\"grey\" title={tooltipText} placement=\"top\">\n          <IconButton>\n            <Icon type=\"question\" />\n          </IconButton>\n        </ExpandedTooltip>\n      </InputAdornment>\n    }\n  />\n</FormControl>\n";
const inputWithFrontIconExample = "\nimport { InputWithIcon } from '@livable/saas-react-components';\n\n<InputWithIcon icon={<Icon type=\"warning\"/>}>\n  <TextField id=\"input-with-icon\" label=\"Label\" variant=\"outlined\" fullWidth />\n</InputWithIcon>\n";
const inputWithPhoneMaskExample = "\nimport { PhoneInput } from '@livable/saas-react-components';\n\n<PhoneInput label={string} fullWidth />\n\n* default label value = \"Phone number\"\n";
const defaultInputExample = "\n<TextField label=\"Label\" variant=\"outlined\" />\n";
const defaultInputSmallExample = "\n<TextField label=\"Label\" variant=\"outlined\" size=\"small\" />\n";
const fullWidthInputExample = "\n<TextField label=\"Label\" variant=\"outlined\" fullWidth />\n";
const inputErrorExample = "\n<TextField label=\"Label\" variant=\"outlined\" error />\n";
const inputErrorSmallExample = "\n<TextField label=\"Label\" variant=\"outlined\" size=\"small\" error />\n";
const inputDisabledExample = "\n<TextField label=\"Label\" variant=\"outlined\" disabled />\n";
const inputDisabledSmallExample = "\n<TextField label=\"Label\" variant=\"outlined\" size=\"small\" disabled />\n";
export default function LvInputs() {
  const classes = useStyles();
  const tooltipText = 'This information may be used for payee details. If there are multiple owners, please list the one we should make the reimbursement to, if applicable.';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Form fields / Inputs"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Inputs "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-text-field/",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Dropzone "), /*#__PURE__*/React.createElement(Link, {
    href: "https://react-dropzone.js.org/",
    target: "_blank"
  }, "(documentation)"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Dropzone, null), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, dropzoneExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "File Uploader")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FileUploader, {
    label: "Attach bill file (optional)"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, fileUploaderExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Checkbox"), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: /*#__PURE__*/React.createElement("span", null, "I agree with", /*#__PURE__*/React.createElement(Link, {
      href: "/"
    }, " Terms and conditions."))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, checkboxExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Radio button"), /*#__PURE__*/React.createElement(RadioGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "female",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: "Female"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, radioButtonExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Toggle"), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, null),
    label: "Text along side action icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, toggleExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Password Input"), /*#__PURE__*/React.createElement("div", {
    className: classes.hintsWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "formHint"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "warning"
  }), "Some unmet requirement."), /*#__PURE__*/React.createElement(Typography, {
    variant: "formHint",
    state: "error"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "warning"
  }), "Make sure it's at least 8 characters."), /*#__PURE__*/React.createElement(Typography, {
    variant: "formHint",
    state: "success"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "success"
  }), "Must contain at least 1 upper case, numeric, and special character.")), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, formHintExample), /*#__PURE__*/React.createElement(PasswordInput, {
    label: "Password"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, passwordInputExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Input with tooltip"), /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, "Username"), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "username",
    type: "text",
    label: "Username",
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: tooltipText,
      type: "grey"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    }))))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, inputWithTooltipExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Input with front icon"), /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "input-with-icon",
    label: "Label",
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, inputWithFrontIconExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Input with phone mask"), /*#__PURE__*/React.createElement(PhoneInput, {
    fullWidth: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, inputWithPhoneMaskExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Default")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    value: "Some text in the input"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    size: "small"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    value: "Some text in the input",
    size: "small"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, defaultInputExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, defaultInputSmallExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Full width")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Username",
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Last name",
    variant: "outlined",
    value: "Some text in the input",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, fullWidthInputExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Error")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    error: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    value: "Some text in the input",
    error: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    size: "small",
    error: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    value: "Some text in the input",
    size: "small",
    error: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, inputErrorExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, inputErrorSmallExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Disabled")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    disabled: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    value: "Some text in the input",
    disabled: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    size: "small",
    disabled: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Label",
    variant: "outlined",
    value: "Some text in the input",
    size: "small",
    disabled: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, inputDisabledExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, inputDisabledSmallExample))))));
}